<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :footer="footer" :config="config"
    ref="table">
    <template #client="{ visible, params }">
      <FreightClient v-if="visible" :rows="params" ref="client" />
    </template>
    <template #rules="{ visible, params }">
      <!-- <FreightRule
        :id="params.row.id"
        :freightName="params.row.title"
        v-if="visible"
      /> -->
      <FreightRule :rows="params" v-if="visible" ref="rule" />
    </template>
    <template #peak="{ visible }">
      <PeakSeason v-if="visible" />
    </template>
    <template #halfPrice="{ visible, params }">
      <halfPrice :infoFields="modals.halfPriceSetting.table.fields" :selectData="selectData" v-if="visible"
        :rows="params" />
    </template>
    <template #discount="{ visible, params }">
      <discount v-if="visible" :rows="params" />
    </template>
    <template #Switch="{ row, field }">
      <i-switch v-if="field.key === 'bind'" v-model="row.is_auto_bind" true-value="YES" false-value="NO"
        @on-change="handleSwitch(row, field.key)" />
      <i-switch v-if="field.key === 'enable'" v-model="row.enable" :true-value="1" :false-value="0"
        @on-change="handleSwitch(row, field.key)" />
    </template>
  </cTable>
</template>

<script>
import {
  getFreight,
  add,
  getDetails,
  update,
  del,
  bindClient,
  getRules,
  Bind,
  setLabel,
  getDiscount,
  switchEnable,
  setTime,
} from "@/api/finance/freight";
import { getChannel } from "@/api/tracker/channel";
import { getCountry } from "@/api/system/country";
import { getMethod } from "@/api/system/method";
import { getCurrency } from "@/api/finance/currency";
import {
  config,
  configAdd,
  configUpdate,
  configDetail,
  configDel,
} from "@/api/finance/halfPrice";

import cTable from "@/base/common/index";
import FreightClient from "./client";
import FreightRule from "./rule";
import FreightRules from "./rules";
import PeakSeason from "./details";
import halfPrice from "./halfPrice";
import discount from "./discount";
import { getUser } from "@/api/user/internal";
import { getOrderType, getAllClient, getCompanies } from "@/api/user/client";
import toPage from "@/base/common/topage";
export default {
  mixins: [toPage],
  name: "freight",
  components: {
    cTable,
    FreightClient,
    FreightRule,
    PeakSeason,
    halfPrice,
    discount,
  },
  async mounted() {
    let star = 7;
    let options = [];
    for (; star <= 10; star += 0.5) {
      options.push({
        label:
          star == 10
            ? this.$t("no discount")
            : (this.$i18n.locale !== "en-US" ? star : star * 10) +
            " " +
            this.$t("Fold"),
        value: star * 10,
      });
    }
    let table = this.$refs["table"];
    this.selectData = {
      client_id: (await getAllClient()).data.payload.rows,
      fromCountry: (
        await getCountry({
          allow_depart: 1,
        })
      ).data.payload.rows,
      toCountry: (
        await getCountry({
          allow_arrive: 1,
        })
      ).data.payload.rows,
      transportCode: (await getMethod()).data.payload.rows,
      currency: (await getCurrency()).data.payload.rows,
      battery: await table.$sel.getData("BATTERY_TYPE"),
      is_smsa: [
        { label: this.$t("YES"), value: 1 },
        { label: this.$t("NO"), value: 0 },
      ],
      is_jt: [
        { label: this.$t("YES"), value: 1 },
        { label: this.$t("NO"), value: 0 },
      ],
      is_smile: [
        { label: this.$t("YES"), value: 1 },
        { label: this.$t("NO"), value: 0 },
      ],
      cod_type: await table.$sel.getData("COD_TYPE"),
      dd_type: [
        { label: "DDP", value: "DDP" },
        { label: "DDU", value: "DDU" },
      ],
      order_type: (await getOrderType()).data.payload.map((t) => {
        return { label: t.name, value: t.value };
      }),
      discount_group: (await getDiscount()).data.payload.map((t) => {
        return { label: t.name, value: t.id };
      }),
      self_pick_up: await table.$sel.getData("SEND_TYPE"),
      time_type: [
        { label: this.$t("outboundTime"), value: 1 },
        { label: this.$t("PODTime"), value: 2 },
      ],
      collection_method: [
        { label: this.$t("freightRata"), value: 1 },
        { label: this.$t("Fixed amount per ticket"), value: 2 },
      ],
      ownership: (await getCompanies()).data.payload,
    };
    this.selectData.from_country = [
      { code: "*" },
      ...this.selectData.fromCountry,
    ];
    this.selectData.to_country = [{ code: "*" }, ...this.selectData.toCountry];
    console.log("this.selectData :>> ", this.selectData);
    this.header.searchs.forEach((item) => {
      if (item.key && this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
      if (this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
    });
    this.modals.setLabel.fields.forEach((item) => {
      if (item.key && this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
    });
    this.modals.halfPriceSettingAdd.fields.forEach((item) => {
      if (item.key && this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
    });
    this.modals.halfPriceSetting.table.header.searchs.forEach((item) => {
      if (item.key && this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
    });
  },
  methods: {
    handleSwitch(row, key) {
      console.log(row, key);
      let page = this.$refs["table"];
      if (key === "bind") {
        page
          .handleRequestMethods(
            "Bind",
            {
              is_auth_bind: row.is_auto_bind,
              id: row.id,
            },
            true,
            true
          )
          .then((res) => { })
          .catch((err) => {
            row.is_auto_bind = "NO";
          });
      }
      if (key === "enable") {
        page
          .handleRequestMethods(
            "switchEnable",
            {
              enable: row.enable,
              id: row.id,
            },
            true,
            true
          )
          .then((res) => { })
          .catch((err) => { });
      }
    },
  },
  data() {
    return {
      will_expire: {},
      selectData: {},
      methods: {
        list: getFreight,
        beforeHandleList: ({ data }) => {
          this.will_expire = data.will_expire;
          return data.rows;
        },
        getDetails,
        add,
        update,
        del,
        bindClient,
        getChannel,
        getCountry,
        getMethod,
        getCurrency,
        getRules,
        Bind,
        getOrderType,
        setLabel,
        config,
        configAdd,
        configUpdate,
        configDetail,
        configDel,
        getUser,
        getAllClient,
        switchEnable,
        setTime,
      },
      config: {},
      modals: {
        setDate: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ ids: row.ids });
              if (data.type == 1) data.time = data.num;
              this.$page
                .handleRequestMethods("setTime", data, true, true)
                .then((res) => {
                  this.$page.getModal("will_expire").close();
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("设置,日期"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date",
                },
              ],
              num: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ type: 24 }, { num: 24 }, { time: 24 }],
          fields: [
            {
              name: this.$tz("类型"),
              key: "type",
              component: "Radio",
              placeholder: () => this.$tz("类型"),
              options: [
                { label: this.$tz("天数"), value: 1 },
                { label: this.$tz("日期"), value: 2 },
              ],
              optionsFn: "",
              optionsKey: "",
              default: 1,
              bind: {
                border: true,
              },
            },
            {
              name: this.$tz("天数"),
              key: "num",
              component: "InputNumber",
              default: 0,
              show: ({ row }) => row.type == 1,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$tz("日期"),
              key: "time",
              placeholder: () => this.$tz("日期"),
              component: "DatePicker",
              format: "YYYY-MM-DD",
              show: ({ row }) => row.type == 2,
              bind: {
                type: "date",
                options: {
                  disabledDate(time) {
                    return time && time.getTime() < Date.now();
                  },
                },
              },
            },
          ],
        },
        will_expire: {
          config: {
            title: this.$tz("报价"),
            modalBind: {
              width: 1000,
            },
          },
          footer: {
            show: () => false,
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$tz("设置,日期"),
                type: "time",
                fnName: "time",
                bind: {
                  type: "primary",
                },
                disabled() {
                  return this.selectAll.length == 0;
                },
              },
            ],
            methods: {
              time() {
                this.$page.getModal("setDate").open({
                  ids: this.selectAll.map((t) => t.quotation_id),
                });
              },
            },
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                type: "checkbox",
                width: 50,
                align: "center",
              },
              {
                name: () => this.$tz("名称"),
                key: "title",
                minWidth: 110,
              },
            ],
          },
        },
        setLabel: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ ids: row.ids });
              this.$page.handleRequestMethods("setLabel", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 800,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              fields: [{ required: true, trigger: "change", type: "array" }],
              cod_type: [{ required: true, trigger: "change", type: "string" }],
              dd_type: [{ required: true, trigger: "change", type: "string" }],
              battery: [{ required: true, trigger: "change", type: "number" }],
              is_smsa: [{ required: true, trigger: "change", type: "number" }],
              is_jt: [{ required: true, trigger: "change", type: "number" }],
              is_smile: [{ required: true, trigger: "change", type: "number" }],
              order_type: [
                { required: true, trigger: "change", type: "number" },
              ],
              discount_group: [
                { required: true, trigger: "change", type: "number" },
              ],
              self_pick_up: [
                { required: true, trigger: "change", type: "number" },
              ],
            },
          },
          grid: [
            {
              fields: 24,
              cod_type: 24,
              order_type: 24,
              battery: 24,
              is_smsa: 24,
              is_jt: 24,
              is_smile: 24,
              discount_group: 24,
              // dd_type:24,
              self_pick_up: 24,
            },
          ],
          fields: [
            {
              name: () => this.$t("type"),
              key: "fields",
              component: "Checkbox",
              options: [
                { label: this.$t("cod_type_txt"), value: "cod_type" },
                { label: this.$t("order_type_t"), value: "order_type" },
                { label: this.$t("battery"), value: "battery" },
                { label: this.$t("discount"), value: "discount_group" },
                // {label: this.$t("DD Type"),value: 'dd_type'},
                { label: this.$t("DeliveryMode"), value: "self_pick_up" },
                { label: this.$t("Assign SMSA"), value: "is_smsa" },
                { label: this.$t("Assign JT"), value: "is_jt" },
                { label: this.$t("Assign Smile"), value: "is_smile" },
              ],
              default: [],
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("Battery"),
              key: "battery",
              width: 130,
              component: "Select",
              placeholder: () => this.$t("Battery"),
              options: [],

              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
            {
              name: () => this.$t("DeliveryMode"),
              key: "self_pick_up",
              width: 130,
              component: "Select",
              placeholder: () => this.$t("DeliveryMode"),
              options: [],

              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
            {
              name: () => this.$t("Assign SMSA"),
              key: "is_smsa",
              width: 130,
              component: "Select",
              placeholder: () => this.$t("Assign SMSA"),
              options: [],
              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
            {
              name: () => this.$t("Assign JT"),
              key: "is_jt",
              width: 130,
              component: "Select",
              placeholder: () => this.$t("Assign JT"),
              options: [],
              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
            {
              name: () => this.$t("Assign Smile"),
              key: "is_smile",
              width: 130,
              component: "Select",
              placeholder: () => this.$t("Assign Smile"),
              options: [],
              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
            {
              name: () => this.$t("cod_type_txt"),
              key: "cod_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("cod_type_txt");
              },
              clearable: true,
              options: [],

              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
            {
              name: () => this.$t("taxationType"),
              key: "dd_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("taxationType");
              },
              bind: {
                border: true,
              },
              options: [],
              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
            {
              name: () => this.$t("discount"),
              key: "discount_group",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("discount");
              },
              clearable: true,
              options: [],

              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
            {
              name: () => this.$t("order_type_t"),
              key: "order_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("order_type_t");
              },
              clearable: true,
              options: [],

              show({ row, field }) {
                return row["fields"].includes(field.key);
              },
            },
          ],
        },
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              let type = "add";
              if (row.id) {
                type = "update";
                data.id = row.id;
              }
              if (row.copy_id) {
                data.copy_id = row.copy_id;
              }
              this.$page.handleRequestMethods(type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 1300,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
              from_country: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              to_country: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              transport_code: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              convert_rate: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              duty_threshold: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              paper_fee: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              vat_rate: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              duty_rate: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              express_currency: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              tax_currency: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              vat_threshold: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              q_type: [
                {
                  required: true,
                  type: "array",
                  trigger: "change",
                },
              ],
              dd_type: [
                {
                  required: true,
                  trigger: "change",
                  min: 1,
                },
              ],
              do_type: [
                {
                  required: true,
                  type: "number",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            {
              shipment_type: 12,
              title: 12,
              q_type: 12,

              from_country: 12,
              to_country: 12,

              transport_code: 12,
              convert_rate: 12
            },
            {
              paper_threshold: 12,
              paper_fee: 12,

              vat_threshold: 12,
              vat_rate: 12,

              duty_threshold: 12,
              duty_rate: 12,
            },
            {
              callBack: 12,
              tax_currency: 12,
              express_currency: 12,
              remote_regions_fee: 12,
              do_type: 12,
              is_open: 12,
              price_type: 12,
              dd_type: 12,
              remarks: 24,
              rules: 24,
            }
          ],
          fields: [
            {
              name: this.$tz("关税资料费,门槛"),
              key: "paper_threshold",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: () => this.$t("TaxRules"),
              key: "rules",
              placeholder: () => this.$t("enter") + this.$t("TaxRules"),
              render(h, p) {
                return h(FreightRules, {
                  props: {
                    rows: p.row,
                  },
                });
              },
              show({ formData }) {
                return (
                  (formData.dd_type == "DDU" && formData.to_country) ||
                  formData.shipment_type === 9
                );
              },
              default: [],
            },
            {
              name: () => this.$t("taxationType"),
              key: "dd_type",
              component: "Radio",
              bind: {
                border: true,
              },
              show: ({ formData }) => formData.shipment_type !== 9,
              options: [
                {
                  label: "DDP",
                  value: "DDP",
                  disabled({ formData }) {
                    return !!formData.id;
                  },
                },
                {
                  label: "DDU",
                  value: "DDU",
                  disabled({ formData }) {
                    return !!formData.id;
                  },
                },
              ],

              default: "DDP",
              methods: {
                "on-change"({ formData, value, fields }) {
                  if (value && !value == "DDU") {
                    formData["tax_currency"] = "USD";
                  } else if (formData.to_country) {
                    console.log(formData.id);
                    this.$page
                      .handleRequestMethods("getRules", {
                        country: formData.to_country,
                        quotation_id: formData.id || 0,
                      })
                      .then((res) => {
                        formData.rules.splice(0, 99);
                        res.payload.forEach((t) => {
                          formData.rules.push(t);
                        });
                      });
                  }
                },
              },
            },
            {
              name: () => this.$t("freightName"),
              key: "title",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("freightName"),
            },
            {
              name: () => this.$t("b2bClient") + this.$t("type"),
              key: "q_type",
              component: "Checkbox",
              bind: {
                border: true,
              },
              options: [
                {
                  label: this.$t("b2bClient"),
                  value: 1,
                  disabled({ formData }) {
                    return formData.id ? true : false;
                  },
                },
                {
                  label: this.$t("branchOffice"),
                  value: 2,
                  disabled({ formData }) {
                    return formData.id ? true : false;
                  },
                },
              ],
              default: [1],
            },
            {
              name: () => this.$t("chargeType"),
              key: "price_type",
              component: "Radio",
              bind: {
                border: true,
              },
              options: [
                {
                  label: this.$t("fullPrice"),
                  value: 1,
                },
                {
                  label: this.$t("halfPrice"),
                  value: 2,
                },
              ],
              default: 1,
            },
            {
              name: () => this.$t("multiplePackageShipment"),
              key: "shipment_type",
              component: "Radio",
              bind: {
                border: true,
              },
              options: [
                {
                  label: this.$t("YES"),
                  value: 9,
                  disabled: ({ formData }) => !!formData.id,
                },
                {
                  label: this.$t("NO"),
                  disabled: ({ formData }) => !!formData.id,
                  value: -1,
                },
              ],
              default: -1,
            },
            {
              name: () => this.$t("from_country"),
              key: "from_country",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("from_country"),
              options: [],
              config: {
                label: "code",
                value: "code",
              },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData["fromCountry"];
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("target_country"),
              options: [],
              config: {
                label: "code",
                value: "code",
              },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData["toCountry"];
                  this.$forceUpdate();
                },
                "on-change"({ formData, value }) {
                  if (value && formData.dd_type == "DDU") {
                    this.$page
                      .handleRequestMethods("getRules", {
                        country: value,
                        quotation_id: formData.id || 0,
                      })
                      .then((res) => {
                        formData.rules.splice(0, 99);
                        res.payload.forEach((t) => {
                          formData.rules.push(t);
                        });
                      });
                  }
                },
              },
            },
            {
              name: () => this.$t("method_code"),
              key: "transport_code",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("method_code"),
              options: [],
              config: {
                label({ row }) {
                  return row.method_name + "(" + row.method_code + ")";
                },
                value: "method_code",
              },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData["transportCode"];
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("convert_rate"),
              key: "convert_rate",
              component: "InputNumber",
              bind: {
                step: 0.01,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("threshold"),
              key: "duty_threshold",
              component: "InputNumber",
              bind: {
                step: 0.0001,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("paper_fee"),
              key: "paper_fee",
              component: "InputNumber",
              bind: {
                step: 0.01,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("vat_rate"),
              key: "vat_rate",
              component: "InputNumber",
              bind: {
                step: 0.0001,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("VAT") + this.$t("threshold1"),
              key: "vat_threshold",
              component: "InputNumber",
              bind: {
                step: 0.0001,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("duty_rate"),
              key: "duty_rate",
              component: "InputNumber",
              bind: {
                step: 0.0001,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("express_currency"),
              key: "express_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("express_currency"),

              options: [],
              config: {
                label: "code",
                value: "code",
              },
              default: "CNY",
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData["currency"];
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("tax_currency"),
              key: "tax_currency",
              component: "Select",
              options: [],
              config: {
                label: "code",
                value: "code",
              },
              disabled: ({ formData }) => !formData["dd_type"] == "DDU",
              placeholder: () => this.$t("select") + this.$t("tax_currency"),
              default: "USD",
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData["currency"];
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("callBack"),
              key: "callBack",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("callBack"),
            },
            {
              name: () => this.$t("remote_regions_fee"),
              key: "remote_regions_fee",
              component: "InputNumber",
              bind: {
                step: 0.01,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("type"),
              key: "do_type",
              component: "Radio",
              options: [
                {
                  label: this.$t("positive"),
                  value: 1,
                },
                {
                  label: this.$t("reverse"),
                  value: 2,
                },
              ],
              bind: {
                border: true,
              },
              default: 1,
            },
            {
              name: () => this.$t("whether") + this.$t("open"),
              key: "is_open",
              component: "Radio",
              bind: {
                border: true,
              },
              options: [
                {
                  label: this.$t("YES"),
                  value: 1,
                },
                {
                  label: this.$t("NO"),
                  value: 0,
                },
              ],
              default: 1,
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3,
              },
              placeholder: () => this.$t("select") + this.$t("Remarks"),
            },
          ],
        },
        showClient: {
          contentSlot: "client",
          config: {
            modalBind: {
              width: 1000,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
            },
            modalContentBind: {
              style: {
                height: "650px",
              },
            },
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("export"),
                key: "export",
                fnName: "export",
                bind: {
                  icon: "md-arrow-down",
                  type: "primary",

                  style: {
                    marginLeft: "5px",
                  },
                },
              },
            ],
            methods: {
              export: () => {
                this.$refs["client"].export();
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
        showRules: {
          contentSlot: "rules",
          config: {
            modalBind: {
              width: 1500,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
            },
            modalContentBind: {
              style: {
                height: "650px",
              },
            },
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("add"),
                key: "add",
                fnName: "add",
                bind: {
                  icon: "md-add",
                  type: "warning",
                  size: "small",
                  style: {
                    marginLeft: "5px",
                  },
                },
              },
            ],
            methods: {
              add: () => {
                this.$refs["rule"].add();
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
        peakSeason: {
          contentSlot: "peak",
          config: {
            modalBind: {
              width: 1300,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
            },
            title: this.$t("high"),
            modalContentBind: {
              style: {
                height: "700px",
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
        discount: {
          contentSlot: "discount",
          config: {
            modalBind: {
              width: 1300,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
            },
            modalContentBind: {
              style: {
                height: "700px",
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
        halfPrice: {
          contentSlot: "halfPrice",
          config: {
            modalBind: {
              width: 1300,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
            },
            modalContentBind: {
              style: {
                height: "700px",
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
        halfPriceSetting: {
          config: {
            listFn: "config",
            modalBind: {
              width: 1300,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
            },
          },
          table: {
            config: {
              height: 600,
            },
            header: {
              searchs: [
                {
                  key: "client_id",
                  placeholder() {
                    return this.$t("select") + this.$t("clientName");
                  },
                  component: "Select",
                  options: [],
                  config: {
                    label: "account",
                    value: "id",
                  },
                },
                {
                  key: "from_country",
                  component: "Select",
                  placeholder: () =>
                    this.$t("select") + this.$t("from_country"),
                  options: [],
                  config: {
                    label: "code",
                    value: "code",
                  },
                },
                {
                  key: "to_country",
                  component: "Select",
                  placeholder: () =>
                    this.$t("select") + this.$t("target_country"),
                  options: [],
                  config: {
                    label: "code",
                    value: "code",
                  },
                },
                {
                  key: "collection_method",
                  component: "Select",
                  placeholder: () =>
                    this.$t("select") + this.$t("BillingMethod"),
                  options: [],
                },
                {
                  key: "time_type",
                  component: "Select",
                  placeholder: () => this.$t("select") + this.$t("timeType"),
                  options: [],
                },
                {
                  key: "data_type",
                  placeholder() {
                    return this.$tz("请选择,类型");
                  },
                  component: "Select",
                  options: [],
                  optionsKey: "HW_BILL_CREATE_MODE",
                },
                {
                  key: "ownership",
                  placeholder() {
                    return this.$t("select") + this.$t("ownership");
                  },
                  component: "Select",
                  options: [],
                  config: {
                    label: "title",
                    value: "id",
                  },
                },
                {
                  key: "salesman_id",
                  component: "Select",
                  placeholder() {
                    return this.$t("select") + this.$t("salesman");
                  },
                  clearable: true,
                  options: [],
                  methods: {
                    async list({ field }) {
                      field.options = (
                        await this.$page.handleRequestMethods("getUser", {
                          standard: "Salesman",
                        })
                      ).payload.rows;
                      this.$forceUpdate();
                    },
                  },
                  config: { label: "account", value: "id" },
                  bind: {
                    style: "width:150px",
                  },
                },
                {
                  key: "keywords",
                  placeholder() {
                    return this.$t("keyword");
                  },
                  bind: {
                    type: "textarea",
                    autosize: { minRows: 1, maxRows: 2 },
                  },
                  component: "Input",
                },
              ],
              btns: {
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      icon: "md-add",
                      type: "warning",
                    },
                  },
                ],
                methods: {
                  add() {
                    this.getModal("halfPriceSettingAdd").open({}, function () {
                      this.setTitle(this.$t("add"));
                    });
                  },
                },
              },
            },
            footer: {
              show: () => true,
            },
            fields: [
              {
                name: () => this.$t("clientName"),
                key: "clientInfo.client_account",
                minWidth: 130,
              },
              {
                name: () => this.$t("shipper_company_cn"),
                key: "clientInfo.shipper_company_cn",
                minWidth: 130,
              },
              {
                name: () => this.$t("ownership"),
                key: "clientInfo.ownership_name",
                minWidth: 130,
              },

              {
                name: () => this.$t("salesman"),
                key: "clientInfo.salesman_account",
                minWidth: 130,
              },
              {
                name: () => this.$t("allow_depart"),
                key: "from_country",
                minWidth: 130,
              },
              {
                name: () => this.$t("target_country"),
                key: "to_country",
                minWidth: 130,
              },
              {
                name: () => this.$tz("类型"),
                key: "data_type_txt",
                minWidth: 130,
              },
              {
                name: () => this.$t("BillingMethod"),
                key: "collection_method_txt",
                minWidth: 130,
              },
              {
                name: () => this.$t("operate1"),
                key: "operator_name",
                minWidth: 130,
              },
              {
                name: () => this.$t("timeType"),
                key: "time_type_txt",
                minWidth: 130,
              },
              {
                name: () => this.$t("Remarks"),
                key: "remarks",
                minWidth: 130,
              },
              {
                name: () => this.$t("Input Time"),
                key: "create_time",
                minWidth: 130,
              },
              {
                name: () => this.$t("upTime"),
                key: "update_time",
                minWidth: 130,
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 120,
                fixed: "right",
                list: [
                  {
                    name: this.$t("halfPriceParams"),
                    type: "halfPrice",
                    fnName: "halfPrice",
                    bind: {
                      type: "primary",
                    },
                  },
                  {
                    name: () => this.$t("update"),
                    type: "update",
                    fnName: "update",
                    bind: {
                      type: "primary",
                    },
                  },
                  {
                    name: () => this.$t("copy"),
                    type: "copy",
                    fnName: "copy",
                    bind: {
                      type: "primary",
                    },
                  },
                  {
                    name: this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                  },
                ],
                methods: {
                  delete({ row }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods(
                          "configDel",
                          row.id,
                          true,
                          true
                        ).then((res) => {
                          this.getModal("halfPriceSetting").getList();
                        });
                      },
                    });
                  },
                  copy({ row }) {
                    this.getModal("halfPriceSettingAdd").open(
                      Object.assign({}, row, { id: "", copy_id: row.id }),
                      function () {
                        this.type = "add";
                        this.setTitle(this.$t("add"));
                      }
                    );
                  },
                  update({ row }) {
                    this.getModal("halfPriceSettingAdd").open(row, function () {
                      this.setTitle(this.$t("update"));
                    });
                  },
                  halfPrice({ row }) {
                    this.getModal("halfPrice").open(row, function () {
                      this.setTitle(this.$t("halfPriceParams"));
                    });
                  },
                },
              },
            ],
          },
          footer: {
            show: () => false,
          },
        },
        halfPriceSettingAdd: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                id: row.id,
                copy_id: row.copy_id,
              });
              let type = "configAdd";
              if (row.id) {
                type = "configUpdate";
              }
              this.$page
                .handleRequestMethods(type, data, true, true)
                .then((res) => {
                  this.$page.getModal("halfPriceSetting").getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 800,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              from_country: [
                { required: true, message: "cannot be empty", trigger: "blur" },
              ],
              to_country: [
                { required: true, message: "cannot be empty", trigger: "blur" },
              ],
              collection_method: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              time_type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              ownership: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "any",
                  trigger: "blur",
                },
              ],
              client_id: [
                {
                  required: true,
                  type: "any",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { ownership: 12, client_id: 12 },
            { from_country: 24 },
            { to_country: 24 },
            { data_type: 24 },
            { collection_method: 24 },
            { time_type: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: this.$t("b2bClient") + this.$t("ownership"),
              key: "ownership",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("ownership"),
              options: [],
              config: {
                label: "title",
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCompanies")
                  ).payload;
                },
                "on-change"({ formData, fields }) {
                  fields.forEach(async (field) => {
                    if (field.key === "client_id") {
                      field.options = [
                        {
                          account: "ALL",
                          ownership_name: "*",
                          id: "*",
                        },
                        ...(
                          await this.$page.handleRequestMethods(
                            "getAllClient",
                            {
                              ownership: formData.ownership,
                            }
                          )
                        ).payload.rows,
                      ];
                    }
                  });
                },
              },
            },
            {
              name: () => this.$tz("类型"),
              key: "data_type",
              component: "Radio",
              options: [],
              optionsFn: "",
              optionsKey: "HW_BILL_CREATE_MODE",
              default: 1,
              disabled: ({ row }) => !!row.id,
              methods: {
                "on-change"({ value, row }) {
                  if (value == 1) {
                    row.collection_method = 1;
                  }
                },
              },
            },
            {
              key: "client_id",
              name() {
                return this.$t("clientName");
              },
              placeholder() {
                return this.$t("select") + this.$t("clientName");
              },
              disabled: ({ row }) => !!row.id,
              component: "Select",
              options: [],
              config: {
                label: "account",
                value: "id",
              },
              methods: {
                list: ({ field }) => {
                  field.options = [
                    {
                      account: "ALL",
                      ownership_name: "*",
                      id: "*",
                    },
                    ...this.selectData[field.key],
                  ];
                },
              },
            },
            {
              name: () => this.$t("from_country"),
              key: "from_country",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("from_country"),
              options: [],
              config: {
                label: "code",
                value: "code",
              },
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("target_country"),
              options: [],
              config: {
                label: "code",
                value: "code",
              },
            },
            {
              name: () => this.$t("BillingMethod"),
              key: "collection_method",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("BillingMethod"),
              options: [],
              disabled: ({ row }) => row.data_type === 1,
              default: 1,
            },
            {
              name: () => this.$t("timeType"),
              key: "time_type",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("timeType"),
              options: [],
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3,
              },
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
            },
          ],
        },
      },
      footer: {
        show: () => true,
        render: (h, p) => {
          if (this.will_expire.total > 0)
            return h(
              "div",
              {
                attrs: { style: "text-align:right;cursor:pointer" },
                on: {
                  click: () => {
                    let list = this.will_expire.rows;
                    this.$refs["table"]
                      .getModal("will_expire")
                      .open(null, function () {
                        this.list = list;
                        this.setTitle(this.$tz("报价"));
                      });
                  },
                },
              },
              [
                h(
                  "span",
                  {},
                  (this.will_expire.day <= 0
                    ? `已过期报价`
                    : this.$tz("{1}天即将过期的报价", this.will_expire.day)) +
                  ":"
                ),
                ,
                h(
                  "span",
                  { attrs: { style: "color:red" } },
                  this.will_expire.total || 0
                ),
              ]
            );
        },
      },
      header: {
        searchs: [
          {
            key: "fromCountry",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code",
            },
          },
          {
            key: "toCountry",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code",
            },
          },
          {
            key: "transportCode",
            placeholder() {
              return this.$t("select") + this.$t("method");
            },
            component: "Select",
            options: [],
            config: {
              label({ row }) {
                return row.method_name + "(" + row.method_code + ")";
              },
              value: "method_code",
            },
          },
          {
            key: "is_open",
            placeholder() {
              return this.$t("whether") + this.$t("open");
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: 1,
              },
              {
                label: this.$t("NO"),
                value: 0,
              },
            ],
          },
          {
            key: "is_auto_bind",
            placeholder() {
              return this.$t("auto bind");
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "dd_type",
            placeholder() {
              return this.$t("DD Type");
            },
            component: "Select",
            options: [
              {
                label: "DDP",
                value: "DDP",
              },
              {
                label: "DDU",
                value: "DDU",
              },
            ],
          },
          {
            key: "cod_type",
            placeholder: () => this.$t("cod_type_txt"),
            component: "Select",
            options: [],
          },
          {
            key: "order_type",
            placeholder: () => this.$t("order_type_t"),
            component: "Select",
            options: [],
          },
          {
            placeholder: () => this.$t("battery"),
            key: "battery",
            component: "Select",
            options: [],
          },
          {
            placeholder: () => this.$t("discount"),
            key: "discount_group",
            component: "Select",
            options: [],
          },
          {
            placeholder: () => this.$t("DeliveryMode"),
            key: "self_pick_up",
            component: "Select",
            options: [],
          },
          {
            placeholder: () => this.$t("Assign SMSA"),
            key: "is_smsa",
            component: "Select",
            options: [],
          },
          {
            key: "price_type",
            component: "Select",
            placeholder() {
              return this.$t("chargeType");
            },
            options: [
              {
                label: this.$t("fullPrice"),
                value: 1,
              },
              {
                label: this.$t("halfPrice"),
                value: 2,
              },
            ],
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 119,
            },
            {
              name: () => this.$t("high"),
              type: "peakSeason",
              fnName: "peakSeason",
              bind: {
                type: "error",
              },
              id: 119,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("Set Label"),
              type: "setLabel",
              fnName: "setLabel",
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("Discounts Setting"),
              type: "discount",
              fnName: "discount",
              bind: {
                type: "warning",
              },
            },
            {
              name: this.$t("halfPriceSetting"),
              type: "halfPrice",
              fnName: "halfPrice",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            halfPrice() {
              this.getModal("halfPriceSetting").open({}, function () {
                this.getList();
                this.setTitle(this.$t("halfPriceSetting"));
              });
            },
            discount() {
              this.getModal("discount").open({}, function () {
                this.setTitle(this.$t("Discounts Setting"));
              });
            },
            setLabel() {
              this.getModal("setLabel").open(
                { ids: this.selectAll.map((t) => t.id) },
                function () {
                  this.setTitle(this.$t("Set Label"));
                }
              );
            },
            peakSeason() {
              this.getModal("peakSeason").open();
            },
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open({
                rules: [],
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("freightName"),
          key: "title",
          align: "left",
          minWidth: 180,
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          width: 80,
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          width: 80,
        },
        {
          name: () => this.$t("DD Type"),
          key: "dd_type",
          width: 80,
        },
        {
          key: "cod_type",
          name: () => this.$t("cod_type_txt"),
          width: 80,
        },
        {
          key: "order_type",
          name: () => this.$t("order_type_t"),
          width: 80,
        },
        {
          name: () => this.$t("battery"),
          key: "battery",
          width: 80,
        },
        {
          name: () => this.$t("discount"),
          key: "discount_group",
          width: 80,
        },
        {
          name: () => this.$t("DeliveryMode"),
          key: "self_pick_up",
          width: 80,
        },
        {
          name: () => this.$t("AssignAgent"),
          key: "is_smsa",
          width: 80,
          methods: {
            render({ value, row }) {
              if (row['is_smsa'] === 1 || row['is_smsa'] === '是') {
                return 'SMSA'
              }
              if (row['is_jt'] === 1 || row['is_jt'] === '是') {
                return '极兔速递'
              }
              if (row['is_smile'] === 1 || row['is_smile'] === '是') {
                return 'iMile'
              }
              return '----'
            },
          },
        },
        {
          name: () => this.$t("chargeType"),
          key: "price_type",
          width: 80,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("fullPrice") : this.$t("halfPrice");
            },
          },
        },
        {
          name: () => this.$t("method_code"),
          key: "transport_code",
          width: 80,
          methods: {
            render: ({ value }) => {
              let title = "";
              this.selectData["transportCode"] &&
                this.selectData["transportCode"].forEach((item) => {
                  if (item.method_code == value) {
                    title = item.method_name + "(" + item.method_code + ")";
                  }
                });
              return value && title;
            },
          },
        },
        {
          name: () => this.$t("threshold"),
          key: "duty_threshold",
          width: 80,
        },
        {
          name: () => this.$t("vat_rate"),
          key: "vat_rate",
          width: 80,
        },
        {
          name: () => this.$t("duty_rate"),
          key: "duty_rate",
          width: 80,
        },
        {
          name: () => this.$t("paper_fee"),
          key: "paper_fee",
          width: 90,
        },
        {
          name: () => this.$t("convert_rate"),
          key: "convert_rate",
          width: 90,
        },
        {
          name: () => this.$t("express_currency"),
          key: "express_currency",
          width: 90,
        },
        // {
        //   name: () => this.$t("callBack"),
        //   key: "callBack",
        //   width: 90
        // },
        {
          name: () => this.$t("b2bClient") + this.$t("type"),
          key: "q_type",
          width: 90,
          methods: {
            render({ value }) {
              return value == 1
                ? this.$t("b2bClient")
                : this.$t("branchOffice");
            },
          },
        },
        {
          name: () => this.$t("type"),
          key: "do_type",
          width: 100,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("positive") : this.$t("reverse");
            },
          },
        },
        {
          name: () => this.$t("open"),
          key: "is_open",
          width: 100,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("YES") : this.$t("NO");
            },
          },
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 200,
        },
        {
          name: () => this.$t("auto bind"),
          key: "bind",
          slot: "Switch",
          width: 100,
        },
        {
          name: () => this.$t("启用"),
          key: "enable",
          slot: "Switch",
          width: 100,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 240,
          fixed: "right",
          list: [
            {
              name: this.$t("b2bClient"),
              type: "client",
              fnName: "client",
              bind: {
                type: "info",
              },
            },
            {
              name: this.$t("freightrule"),
              type: "rule",
              fnName: "rule",
              bind: {
                type: "warning",
              },
              id: 122,
            },
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 120,
            },
            {
              name: this.$t("copy"),
              type: "copy",
              fnName: "copy",
              bind: {
                type: "error",
              },
              id: 119,
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 121,
            },
            // {
            // 	name: this.$t("Delivery Fail Params"),
            // 	type: "halfPrice",
            // 	fnName: "halfPrice",
            // 	// show:({row})=>row.price_type != 1
            // }
          ],
          methods: {
            halfPrice({ row }) {
              this.getModal("halfPrice").open(row, function () {
                this.setTitle(row.title + this.$t("Delivery Fail Params"));
              });
            },
            client({ row }) {
              this.getModal("showClient").open(row, function () {
                this.setTitle(
                  row.title + this.$t("b2bClient") + this.$t("list")
                );
              });
            },
            rule({ row }) {
              this.getModal("showRules").open(row, function () {
                this.setTitle(row.title + this.$t("freightrule"));
              });
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                let data = res.payload;
                data.q_type = [data.q_type];
                let dates = {};
                data.rules.forEach((t) => {
                  if (!dates[t.batch_no]) {
                    t.start_time = new Date(t.start_time);
                    t.end_time = new Date(t.end_time);
                    dates[t.batch_no] = {
                      start_time: t.start_time,
                      end_time: t.end_time,
                    };
                  } else {
                    t.start_time = dates[t.batch_no].start_time;
                    t.end_time = dates[t.batch_no].end_time;
                  }
                });
                console.log(data);
                this.getModal("add").open(data, function () {
                  this.setTitle(this.$t("update"));
                });
              });
            },
            async copy({ row }) {
              const res = await this.handleRequestMethods("getDetails", row.id);
              let data = res.payload;
              data.q_type = [data.q_type];
              data.copy_id = row.id;
              data.id = "";
              data.dd_type = data.dd_type.split(",");
              this.getModal("add").open(data, function () {
                this.setTitle(this.$t("copy"));
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
